import posthog from "posthog-js"

// posthog-js in cookieless mode (BLU-10): memory persistence needs no consent
// banner and suits school networks, and because capture requires JS execution,
// SafeLinks/scanner prefetch never pollutes the funnel. No autocapture, no
// pageviews, no session recording — the two check-in form events are the whole
// surface, and their properties carry IDs only.
export interface AnalyticsConfig {
  key: string
  host: string
}

let initialized = false

export function captureEvent(
  config: AnalyticsConfig | null | undefined,
  event: string,
  properties: Record<string, string | number | null>,
) {
  if (!config?.key || typeof window === "undefined") return

  if (!initialized) {
    posthog.init(config.key, {
      api_host: config.host,
      persistence: "memory",
      autocapture: false,
      capture_pageview: false,
      disable_session_recording: true,
    })
    initialized = true
  }

  posthog.capture(event, properties)
}
